// extracted by mini-css-extract-plugin
export default {"solutionsList":"VIZrl"};